"use strict";

var _classCallCheck = require("/Users/ericgit/Dev/Projects/personal/portfolio/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ericgit/Dev/Projects/personal/portfolio/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbsorberSize = void 0;

var AbsorberRandomSize_1 = require("./AbsorberRandomSize");

var AbsorberSize = /*#__PURE__*/function () {
  function AbsorberSize() {
    _classCallCheck(this, AbsorberSize);

    this.density = 5;
    this.random = new AbsorberRandomSize_1.AbsorberRandomSize();
    this.value = 50;
  }

  _createClass(AbsorberSize, [{
    key: "load",
    value: function load(data) {
      if (data !== undefined) {
        if (data.density !== undefined) {
          this.density = data.density;
        }

        if (data.value !== undefined) {
          this.value = data.value;
        }

        if (data.random !== undefined) {
          if (typeof data.random === "boolean") {
            this.random.load({
              enable: data.random
            });
          } else {
            this.random.load(data.random);
          }
        }

        if (data.limit !== undefined) {
          this.limit = data.limit;
        }
      }
    }
  }]);

  return AbsorberSize;
}();

exports.AbsorberSize = AbsorberSize;